/**
 * Central object used for Store UserProfiles module
 */

import type IUserProfile from '@/models/UserProfile/UserProfile'

interface UserProfileState {
  user_profile: null | IUserProfile
  user_profiles: null | IUserProfile[]
}

export const useUserProfilesStore = defineStore('userProfile', {
  state: (): UserProfileState => ({
    user_profile: null,
    user_profiles: null,
  }),

  actions: {
  },

  getters: {
  },
})
